// extracted by mini-css-extract-plugin
module.exports = {"row":"TaskAttachment-module__row--1rfnq","attachmentMenuIcon":"TaskAttachment-module__attachmentMenuIcon--1f90u"};